import React,{useEffect, useState} from 'react';
import '../css/MobilePhoneCalls.css';
import { useSelector, useDispatch } from 'react-redux';
import { Box, Card, CardContent, Typography, Accordion, AccordionSummary, AccordionDetails, Stack } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import '../css/MobilePhoneCalls.css';
import {APIGetPhoneCalls} from '../APIS/wupuapAPI.js'
import parse from 'html-react-parser';

const MobilePhoneCalls = (props) => {
    const dispatch = useDispatch();

    const [columns,setColumns] = useState([])
    const forwardCursor = useSelector(state => state.data.forwardCursor);
    const backwardCursor = useSelector(state => state.data.backwardCursor);
    const [dataloaded,setDataLoaded] = useState(false)
    const [phonecalls,setPhoneCalls] = useState([])
    const auth = useSelector(state => state.auth)

    const summaryFields = ['CompanyName', 'FullName'];
    useEffect(()=> {
      const LoadData = async () => {
        const ret = await APIGetPhoneCalls({token: auth.token,ttp_lead_id: props.data.uid,});
        if(ret.status)
            setPhoneCalls(ret.data)
        else
            setPhoneCalls([])
      }

      if(auth.token > "" && typeof props.data !== 'undefined' && props.data.id > "" )
            LoadData();
    },[props.data, auth.token]);

  return (
    <Box>
      <Stack spacing={2}>
        {(!phonecalls || phonecalls.length === 0) &&
                  <Card key='no_phone_call' variant="outlined">
                    <CardContent>
                        <h4>There are No Phone Calls set</h4>
                    </CardContent>
                  </Card>
        }
        {phonecalls && phonecalls.length > 0 && phonecalls.map((call) => {
           let phonesummary = call.notes
           if(call.notes.length > 40 )
            phonesummary = `${call.notes.substring(0,40)}...`
          return (
          <Card key={call.phonecall_uid} variant="outlined">
            <CardContent>
                  <Typography key={`summary_${call.phonecall_uid}`} variant="subtitle1">
                    <span className='phonecall_title' >Number: {call.number_dialled}</span>
                    <span className='phonecall_date'>Date/Time: {call.datetime_dialled}</span>
                    <span className='phonecall_date'>Duration {call.call_durations} seconds</span>
                    <span className='phonecall_date'>Callback Set: {call.callback_set??"None"}</span>
                    <span className='phonecall_outcome'>Outcome: {call.call_outcome}</span>
                    <span className='phonecall_addedby'>Added By: {call.added_by}</span>
                    <span className='phonecall_notesummary'>Notes Summary: {phonesummary}</span>
                  </Typography>
              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography className='viewphonecalls' >View Call Notes</Typography>
                </AccordionSummary>
                <AccordionDetails>
                {parse(`<div className='phonecall_text'>${call.notes}</div><br/>`)}
                </AccordionDetails>
              </Accordion>
            </CardContent>
          </Card>
        )})}
      </Stack>
    </Box>
  );
};

export default MobilePhoneCalls;
